/**
 * Возврат на экран, с которого увело на форму входа.
 *
 * Сессия кончилась — человека уводят на `/login`, а адрес, где он был, едет
 * параметром `back`. После входа — туда же, а не на «Планы».
 *
 * Параметр не `to`: его Refine в `useLogin` берёт сам и ведёт по нему без
 * проверки, а адрес из строки браузера — чужой ввод. `back` читаем только мы.
 */

const HOME = "/plans";

/** Адрес формы входа с текущим экраном в `back`. */
export function loginPath(): string {
  const { pathname, search, hash } = window.location;
  if (pathname === "/" || pathname.startsWith("/login")) return "/login";
  return `/login?back=${encodeURIComponent(pathname + search + hash)}`;
}

/** Куда вести после входа: только свой путь, иначе «Планы». */
export function returnPath(search: string = window.location.search): string {
  const back = new URLSearchParams(search).get("back");
  // `//host` и `/\host` браузер читает как чужой домен.
  if (!back || !back.startsWith("/") || back.startsWith("//") || back.startsWith("/\\"))
    return HOME;
  if (back.startsWith("/login")) return HOME;
  return back;
}
